"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _servicesAPIClient = require('../services/APIClient');

var _servicesAPIClient2 = _interopRequireDefault(_servicesAPIClient);

var _entitiesUser = require('../entities/User');

var _entitiesUser2 = _interopRequireDefault(_entitiesUser);

/**
* Flag for avoid multiple instances of Session class
* @type {boolean}
*/
var singletonSession = false;

/**
* Handles auth process and sets the token on APICLient for future queries.
*/

var Session = (function () {
    /**
    * Builds the object and initializes variables.
    * @constructor
    */

    function Session() {
        _classCallCheck(this, Session);

        /**
        * @type {string}
        */
        this._token = "";
        /**
        * @type {string}
        */
        this._clientId = "";
        /**
        * @type {string}
        */
        this._secretId = "";
        /**
        * @type {string}
        */
        this._scopes = "";
        /**
        * @type {string}
        */
        this._redirect_uri = "";
    }

    /**
    * Sets variables by given data.
    * @param {object} data
    */

    _createClass(Session, [{
        key: 'config',
        value: function config(data) {
            this._token = data.token;
            this._clientId = data.clientId;
            this._secretId = data.secretId;
            this._scopes = data.scopes;
            this._redirect_uri = data.redirect_uri;
        }

        /**
        * Sets a token keeping it internally and passing it to APIClient
        * @param {string} value The token
        */
    }, {
        key: 'login',

        /**
        * Builds the authorization url with the stored parameters.
        * @return {Promise}
        */
        value: function login() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                var loginUrl = 'https://accounts.spotify.com/en/authorize?response_type=token&client_id=' + _this._clientId + '&redirect_uri=' + encodeURIComponent(_this._redirect_uri) + (_this._scopes ? '&scope=' + encodeURIComponent(_this._scopes) : '');
                resolve(loginUrl);
            });
        }
    }, {
        key: 'getCurrentUser',
        value: function getCurrentUser() {
            return _entitiesUser2['default'].findMe();
        }
    }, {
        key: 'token',
        set: function set(value) {
            this._token = value;
            _servicesAPIClient2['default'].token = this._token;
        }
    }]);

    return Session;
})();

if (!singletonSession) {
    singletonSession = new Session();
}

exports['default'] = singletonSession;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/classes/Session.js
 ** module id = 150
 ** module chunks = 0
 **/